import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "interest-experiences--sprite",
  "use": "interest-experiences--sprite-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol viewBox=\"0 0 14 13\" id=\"interest-experiences--sprite\">\n<path d=\"M14 9.63889V12.9833H7.35V9.63889H14ZM0 12.9833H6.65V9.63889H0V12.9833ZM5.28889 0.5H2.45V1.82222H5.25V0.5H5.28889ZM11.55 0.5H8.75V1.82222H11.55V0.5ZM7.97222 9.17222H13.2611L12.1722 2.32778H11.55H8.75H8.01111V2.95H7H6.02778V2.32778H5.28889H2.45H1.82778L0.738889 9.17222H6.02778V5.20556H7H7.97222V9.17222Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol